import { Autocomplete, TextField, useMediaQuery } from '@mui/material';
import EmptyCell from 'components/EmptyCell';
import { useChallengeContextContext } from 'context/ChallengeContext/ChallengeContext';
import usePartsQuery from 'hook/usePartsQuery';
import React from 'react';
import { EditorProps } from 'react-data-grid';
import { RootStyle } from './style';

export function PartAutoCompleteComponent<TRow, TSummaryRow>({
  row,
  column,
  onRowChange,
  onClose,
}: EditorProps<TRow, TSummaryRow>) {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const { partQuery } = useChallengeContextContext();

  const onChangeValue = (value: Part) => {
    onRowChange(
      {
        ...row,
        alt_workouts_part: value.id,
      },
      true,
    );
    onClose();
  };

  // if (
  //   (row as any).name === 'isRest' ||
  //   (row as any).workout_id ||
  //   ((row as any).workout_ids && (row as any).workout_ids.length > 0)
  // ) {
  //   return <EmptyCell />;
  // }

  return (
    <Autocomplete
      loading={partQuery.isLoading}
      autoSelect
      autoHighlight
      getOptionLabel={(option) => option.name}
      sx={{ width: '100%', flex: 1 }}
      freeSolo
      options={[...new Set(partQuery.data)]}
      onChange={(_, value) => onChangeValue(value as Part)}
      renderInput={(params) => (
        <TextField
          sx={{ input: { color: prefersDarkMode ? 'white' : 'black' } }}
          autoFocus
          {...params}
          size='small'
          type='text'
          placeholder='대체 운동 부위'
        />
      )}
    />
  );
}
